export default "__VITE_ASSET__ebca4907__"